var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiveStream = function SvgLiveStream(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 6,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.09 16.789 14.321 13.9C11.663 16.448 10 20.027 10 24s1.663 7.552 4.321 10.1l2.769-2.889A9.97 9.97 0 0 1 14 24c0-2.833 1.19-5.39 3.09-7.211M33.679 13.9l-2.769 2.889A9.97 9.97 0 0 1 34 24a9.97 9.97 0 0 1-3.09 7.211l2.769 2.889C36.337 31.552 38 27.973 38 24s-1.663-7.552-4.321-10.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.561 11.021-2.779-2.9C4.605 12.125 2 17.757 2 24s2.605 11.875 6.782 15.879l2.779-2.9C8.142 33.701 6 29.1 6 24s2.142-9.701 5.561-12.979M39.218 8.121l-2.779 2.9C39.858 14.299 42 18.9 42 24s-2.142 9.701-5.561 12.979l2.779 2.9C43.395 35.875 46 30.243 46 24s-2.605-11.875-6.782-15.879"
  }))));
};
export default SvgLiveStream;